export const getSignInPath = () => "/login";

export const getMemoriesPath = () => "/app/memories";

export const getMemoryDetailPath = (memoryId = ":memoryId") =>
  `/app/memories/${memoryId}`;

export const getChatPath = () => "/app/chat";

export const getChatConversationPath = (conversationId = ":conversationId") =>
  `/app/chat/${conversationId}`;

export const getAccountPath = () => "/app/account";

export const getDeveloperPath = () => "/app/developer";

export const getApiKeysPath = () => "/app/api-keys";
